export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[640px] md:min-h-[720px] flex items-center overflow-hidden"
      style={{ backgroundColor: '#160806' }}
    >
      {/* Background image + overlays */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20manga%20background%2C%20deep%20crimson%20and%20near-black%20tones%2C%20ink%20brush%20splatter%20abstract%20textures%2C%20japanese%20sumi-e%20style%2C%20fiery%20dark%20red%20energy%20on%20almost%20black%20canvas%2C%20cinematic%20martial%20arts%20mood%2C%20no%20text%2C%20no%20characters&width=1600&height=900&seq=hero-baki-bg2&orientation=landscape&nocache=true"
          alt="刃牙漫画主题背景"
          className="w-full h-full object-cover opacity-50"
          onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/65 to-black/30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          {/* Left: text content */}
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-6"
              style={{ borderColor: 'rgba(220,38,38,0.4)', backgroundColor: 'rgba(220,38,38,0.12)' }}>
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              <span className="text-xs md:text-sm font-medium text-primary-400 whitespace-nowrap">热血格斗 · 经典连载</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4" style={{ color: '#f5f0eb' }}>
              刃牙漫画<span style={{ color: '#e8a020' }}> — </span>刃牙漫画全集在线免费阅读
            </h1>

            <p className="text-base md:text-lg font-heading mb-6" style={{ color: 'rgba(245,240,235,0.85)' }}>
              从第一部到最新话，下拉式畅享全系列
            </p>

            <p className="text-sm md:text-base leading-relaxed mb-8 max-w-[580px] mx-auto lg:mx-0" style={{ color: 'rgba(245,240,235,0.65)' }}>
              刃牙漫画完整版大合集，一次性收录全部章节。无论你是从刃牙第一部开始追的老读者，
              还是刚入坑的新粉，这里都为你准备了从经典到最新的刃牙漫画大全。下拉式阅读体验，
              手机电脑无缝切换，随时随地畅享热血格斗世界。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading" style={{ color: '#e8a020' }}>1200+</div>
                <div className="text-xs md:text-sm mt-1" style={{ color: 'rgba(245,240,235,0.5)' }}>全系列章节</div>
              </div>
              <div className="w-px h-10 hidden sm:block" style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading" style={{ color: '#e8a020' }}>7</div>
                <div className="text-xs md:text-sm mt-1" style={{ color: 'rgba(245,240,235,0.5)' }}>系列作品</div>
              </div>
              <div className="w-px h-10 hidden sm:block" style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading" style={{ color: '#e8a020' }}>持续</div>
                <div className="text-xs md:text-sm mt-1" style={{ color: 'rgba(245,240,235,0.5)' }}>同步更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#carousel')}
                className="cursor-pointer whitespace-nowrap px-8 py-3 rounded-full font-semibold text-sm transition-colors"
                style={{ backgroundColor: '#dc2626', color: '#fff' }}
                onMouseOver={e => (e.currentTarget.style.backgroundColor = '#b91c1c')}
                onMouseOut={e => (e.currentTarget.style.backgroundColor = '#dc2626')}
              >
                <i className="ri-book-open-line mr-2"></i>开始阅读
              </button>
              <button
                onClick={() => scrollTo('#index')}
                className="cursor-pointer whitespace-nowrap px-8 py-3 rounded-full font-medium text-sm transition-colors"
                style={{ border: '1px solid rgba(245,240,235,0.3)', color: 'rgba(245,240,235,0.9)', backgroundColor: 'transparent' }}
                onMouseOver={e => (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)')}
                onMouseOut={e => (e.currentTarget.style.backgroundColor = 'transparent')}
              >
                <i className="ri-menu-search-line mr-2"></i>查看目录
              </button>
            </div>
          </div>

          {/* Right: hero visual */}
          <div className="flex-shrink-0 flex justify-center lg:justify-end">
            <div className="relative w-[260px] h-[360px] md:w-[320px] md:h-[440px] lg:w-[360px] lg:h-[480px] rounded-2xl overflow-hidden"
              style={{ boxShadow: '0 25px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(220,38,38,0.2)' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Powerful%20muscular%20fighter%20in%20dramatic%20manga%20art%20style%2C%20dark%20crimson%20and%20amber%20color%20scheme%2C%20ink%20brush%20energy%20strokes%20surrounding%20silhouette%2C%20intense%20battle%20aura%2C%20japanese%20sumi-e%20brushwork%20fusion%20with%20modern%20manga%2C%20dark%20moody%20background%2C%20no%20text&width=720&height=960&seq=hero-baki-visual2&orientation=portrait&nocache=true"
                alt="刃牙漫画主视觉 - 热血格斗主题插画"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const img = e.currentTarget as HTMLImageElement;
                  const parent = img.parentElement;
                  if (parent) {
                    parent.style.background = 'linear-gradient(135deg, #2d0a0a 0%, #1a0606 50%, #0d0303 100%)';
                    img.style.display = 'none';
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-0 right-0 text-center">
                <span className="text-xs px-3 py-1 rounded-full" style={{ backgroundColor: 'rgba(220,38,38,0.7)', color: '#fff' }}>
                  刃牙漫画全集
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}